module.exports = __webpack_public_path__ + "static/media/zalopay-logo.bc462e19.png";